import BaseController from '../baseSystemController';
import { format } from '../../../../utils/formatCurrency';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../../utils/constants';

export default class ControllerBalanceInfo extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eElementsTypes = {
      EET_LABEL: 'label',
      EET_VALUE: 'value',
    };
    this._localizations = {
      [this._eElementsTypes.EET_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.infoPanel.balance`,
    };

    this._balance = 0;
    this.init(container);
  }

  updateBalance(value) {
    this._balance = value;
    this._update();
  }

  _update() {
    const decimals = window.OPWrapperService.currencyInfo.decimals;
    const currency = window.OPWrapperService.currencyInfo.currency;

    const formattedBalance = format(this._balance, decimals, true);
    const text = `${formattedBalance} ${currency.toUpperCase()}`;
    this.set(this._eElementsTypes.EET_VALUE, text);
  }

  _getMarkup() {
    return `<span>
              <label id=${this.interactiveElementsIds[this._eElementsTypes.EET_LABEL]}>
                ${this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL])}
              </label>
              <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_VALUE]}>
                0.12345678
              </span>
            </span>`
  }
}
